import FormValidation from '../components/form-validation';
import { listActionStandard } from './helper';
import { messageBoxSuccess, messageBoxError } from '../components/message-box';

class PopupNewGroup {
  public formNewGroup: HTMLFormElement;
  public newGroupButton: HTMLButtonElement | null;

  private formValidation: FormValidation;

  async handlerFormSubmit() {

    const data = new FormData(this.formNewGroup);

    // @ts-ignore
    const typeId = window.LIST_TYPES.filter((listType) => listType.handle === data.get('typeId'))[0].id;
    data.set('typeId', typeId);

    try {
      const res = await listActionStandard(data);

      const url = new URL(window.location as unknown as string);

      messageBoxSuccess({
        contentDe: 'Gruppe wurde erfolgreich angelegt.',
        contentEn: 'Successfully added group.',
      });

      url.searchParams.set('group', res.id);
      window.history.pushState({}, '', url as unknown as string);
      setTimeout(() => {window.location.reload()}, 200);
    } catch (e) {
      console.error(e);

      messageBoxError({
        contentDe: 'Es ist ein Fehler aufgetreten. Gruppe konnte nicht angelegt werden.',
        contentEn: 'An error appeared. Could not add group.',
      });
    }
  }

  bindings() {
    if (this.formNewGroup) {
      this.formNewGroup.reset();

      this.formValidation = new FormValidation(
        this.formNewGroup,
        this.handlerFormSubmit.bind(this)
      );
      this.formValidation.init();
    }
  }

  cache() {
    this.formNewGroup = document.querySelector('#wishlist-popup-new-group form') as HTMLFormElement;
    this.newGroupButton = document.querySelector('.m-wishlist-group-filter .m-circle-btn');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default PopupNewGroup;
